import { Link } from 'react-router-dom';

function RelatedProduct(props) {
  const to = `/products/${props.id}`;
  let percentOff;
  let offPrice: any = `${props.price}$`;

  if (props.percentOff && props.percentOff > 0) {
    percentOff = (
      <div
        className="badge bg-dim py-2 text-white position-absolute"
        style={{ top: '0.5rem', right: '0.5rem' }}
      >
        {props.percentOff}% OFF
      </div>
    );

    offPrice = (
      <>
        <del>{props.price}$</del> {props.price - (props.percentOff * props.price) / 100}$
      </>
    );
  }

  return (
    <Link className="col text-decoration-none" to={to}>
      <div className="card shadow-sm">
        {percentOff}
        <img className="card-img-top bg-dark cover" height="200" alt="" src={props.image} />
        <div className="card-body">
          <h5 className="card-title text-center text-dark text-truncate">{props.name}</h5>
          <p className="card-text text-center text-muted">{offPrice}</p>
        </div>
      </div>
    </Link>
  );
}

export default RelatedProduct;
